
<div class="ToolPickerHUD">
  <div class="ToolPickerHUD_Tools" v-on:touchstart.stop>
    <div
      class="CircleShadowButton m-previous-page"
      v-on:click="previousPage"
      v-if="shouldShowPreviousPageButton"
    >
      <img src="/img/icons/caret-back-outline-white.svg" />
    </div>

    <div
      v-for="tool in toolsOnThisPage"
      v-bind:key="tool.toolType"
      v-bind:class="toolClass(tool)"
      v-on:click="setTool(tool)"
    >
      <img v-bind:src="tool.icon" v-bind:style="tool.style" />
      <div
        :class="{
          CircleShadowButton_HoverText: true,
          'm-right': true,
        }"
      >
        <span
          >{{ tool.label }}
          <span v-if="tool.hotkey">({{ tool.hotkey }})</span></span
        >
      </div>
    </div>

    <div class="ToolPickerHUD_Spacing MobileOnly"></div>
    <div
      class="CircleShadowButton m-next-page"
      v-on:click="nextPage"
      v-if="shouldShowNextPageButton"
    >
      <img src="/img/icons/caret-forward-outline-white.svg" />
    </div>
  </div>
</div>
